import { render, staticRenderFns } from "./LivePage.vue?vue&type=template&id=0ec664c2&scoped=true&"
import script from "./LivePage.vue?vue&type=script&lang=js&"
export * from "./LivePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec664c2",
  null
  
)

export default component.exports